import React, {useEffect} from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import ZFLOCE from "../../components/ZFLOCE";
import { Link } from "react-router-dom";

export default function AllProjectsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const projects = [
    { title: "Aasenar", type: "Website Development", image: "images/E-1.png", backgroundImage: "images/bg-project-1.jpeg", backgroundImage2: "images/glass-effect.png" },
    { title: "Leadlytics", type: "Website Development", image: "images/E-2.png", backgroundImage: "images/bg-project-2.jpeg" },
    { title: "Dream PG", type: "Mobile App Development", image: "images/E-3.png", backgroundImage: "images/bg-dream-pg.png" },
    { title: "ZoomInfo", type: "Website Development", image: "images/E-4.png", backgroundImage: "images/bg-project-3.jpeg", backgroundImage2: "images/glass-effect-2.png" },
  ];

  return (
    <div className="container mx-auto py-16 relative">
      <div className="absolute top-6 left-6 right-6 flex justify-between items-center z-50">
        <Link to="/">
          <img src="images/dropdown-logo.png" alt="Logo" className="h-6 w-auto" />
        </Link>
        <Link to="/">
        <button className="p-2 rounded-full bg-gray-100 hover:bg-gray-300 transition" onClick={() => console.log("Close button clicked")}>
          <X size={24} className="text-gray-700" />
        </button>
        </Link>
      </div>

      <div className="overflow-hidden relative w-full mt-[50px]">
        <motion.div
          className="flex whitespace-nowrap w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
        >
          {[...Array(2)].map((_, i) => (
            <span key={i} className="flex gap-12 text-9xl font-compacta font-semibold uppercase">
              {[...Array(10)].map((_, j) => (
                <span key={j} className="flex items-center gap-4">
                  <motion.img
                    src="images/wheel.svg"
                    alt="Star"
                    animate={{ rotate: [360, 0] }}
                    transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
                    className="inline-block mx-2 origin-center w-20 h-20"
                  />
                  CLIENTS
                </span>
              ))}
            </span>
          ))}
        </motion.div>
      </div>

      <p className="text-xl max-w-2xl mx-auto text-center text-gray-700">
        See how we partner with visionary teams to build brands that stand out and push the boundaries of innovation.
      </p>

      <div className="flex items-center justify-center bg-[url('/public/images/bg-3.png')] bg-cover bg-no-repeat py-[100px] sm:py-2">
        <div className="container flex flex-col items-center gap-12 sm:px-[20px] lg:px-[50px] xl:px-[200px]">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-1 sm:grid-cols-1">
            {projects.map((project, index) => (
              <ZFLOCE
                key={index}
                projectTitle={project.title}
                projectType={project.type}
                imageSrc={project.image}
                backgroundImage={project.backgroundImage}
                backgroundImage2={project.backgroundImage2}
                className="hover:shadow-2xl transition-transform transform hover:scale-105"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
